/** The placement-selection signal shared by `world-map-pane.tsx` and `world-three-pane.tsx`, reset whenever a different region entry is selected. */

import { createEffect, createSignal, type Accessor } from "solid-js";

export interface WorldSelection {
  readonly selectedIndex: Accessor<number | undefined>;
  readonly setSelectedIndex: (index: number | undefined) => void;
}

export function useWorldSelection(entryPath: Accessor<string>): WorldSelection {
  const [selectedIndex, setSelectedIndex] = createSignal<number | undefined>(undefined);
  createEffect(() => {
    void entryPath();
    setSelectedIndex(undefined);
  });
  return { selectedIndex, setSelectedIndex };
}
